import { defineMessages } from 'react-intl';

export default defineMessages({
  id: {
    description: 'ID Label which will then show the id of an entity',
    defaultMessage: 'ID',
  },
  created: {
    description: 'Created At Label which will then show a date',
    defaultMessage: 'Created',
  },
  createdBy: {
    description: 'Created By Label which will then show a users name',
    defaultMessage: 'Created By',
  },
  updatedAt: {
    description: 'Last modified Label which will then show a date',
    defaultMessage: 'Last Modified',
  },
  copySuccessful: {
    description: 'Snackbar notification for when user presses copy Id',
    defaultMessage: 'Copied to clipboard',
  },
});
